import type { ConvexQueryClient } from "@convex-dev/react-query";
import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { RouteErrorFallback } from "@/components/ui/route-error-fallback";
import { Toaster } from "@/components/ui/sonner";

export type RouterContext = {
	queryClient: QueryClient;
	convexQueryClient: ConvexQueryClient;
};

export const Route = createRootRouteWithContext<RouterContext>()({
	// Auth is handled by AuthProvider before router renders
	// Route-specific guards (org checks) are in child routes
	component: RootLayout,
	errorComponent: RouteErrorFallback,
});

function RootLayout() {
	return (
		<>
			<Outlet />
			<Toaster position="bottom-right" closeButton expand={false} />
			<TanStackRouterDevtools position="bottom-right" />
		</>
	);
}
